import React from 'react';
import PropTypes from 'prop-types';
import css from '../partials/Grid.css';
import { ReportFieldTypes } from '../../utils/consts';
import CellLoader from './CellLoader';

const TotalsCell = ({ valueFormatted, isLoading = false, colDef = {} }) => {
    if (colDef?.type === ReportFieldTypes.DIMENSION) return null;

    if (isLoading) return <CellLoader loaderClass={css.loadingCell} />;

    return <span>{valueFormatted}</span>;
};

TotalsCell.propTypes = {
    valueFormatted: PropTypes.string,
    isLoading: PropTypes.bool,
    colDef: PropTypes.objectOf(PropTypes.any),
};

export default TotalsCell;
